import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function BenefitsSection() {
  const benefits = ['Detectar problemas simples.', 'Comprender mejor los diagnósticos.', 'Evitar gastos innecesarios.', 'Comparar presupuestos con criterio.', 'Comprar vehículos usados con mayor seguridad.', 'Prepararte para emergencias.', 'Ahorrar dinero todos los meses.'];
  return <section className="py-20 md:py-32 bg-[#171717] border-b border-[#262626]" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-19">
        <SectionReveal className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-21">
            Después de leer este material vas a poder:
          </h2>
          <div className="w-24 h-1 bg-[#F59E0B] mx-auto rounded-full" data-id="element-22"></div>
        </SectionReveal>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-23">
          {benefits.map((benefit, idx) => <StaggerItem key={idx} className="bg-[#0a0a0a] border border-[#262626] p-5 rounded-sm flex items-center gap-4 hover:border-[#F59E0B]/30 transition-colors" data-id="element-24">
              <CheckCircle2 className="w-6 h-6 text-[#F59E0B] flex-shrink-0" data-id="element-25" />
              <span className="text-lg text-[#F5F5F5] font-medium" data-id="element-26">
                {benefit}
              </span>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}